import React from 'react';
import Header from '../../Offline/Header';
import { ErrorBarra } from 'errores';
import SinCompras from './SinCompras';
import Compras from './Compras';
import TerminosCondiciones from '../../TerminosCondiciones';
import BotonCerrarSesion from '../BotonCerrarSesion';
import { withRouter } from 'react-router';
import "./Inicio.css"
import "./inicio.scss"
import useResizeEventIframe from '../../Utils/Iframe';
import Loading from '../../componentes/cupra/controls/Loading/index.js';

class Inicio extends React.Component {

    constructor(props) {
        super(props);
        this.state = { compras: [], error: false, errorMensaje: "", cargando: true, mostrarFormasContactoModal: false, aceptoTerminos: false };
        this.ref = React.createRef();
        this.cerrarError.bind(this);
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_URL_DTO_BACK + "compras", {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + this.props.servicio.getToken()
            }
        }).then(async res => {
            let responseBody = await res.json();
            if (res.status < 299) {
                this.setState({ error: false, compras: responseBody.mensaje, cargando: false })
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        }).catch(errorP => {
            console.log(errorP);
            if (errorP.toString().includes("NetworkError")) {
                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                    this.props.servicioFirebase.registrarErrorAnalitica(errorP, false);
                }
                this.setState({ error: true, errorMensaje: "Por el momento no podemos conectar con el servicio.", cargando: false });
            } else {
                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                    this.props.servicioFirebase.registrarErrorAnalitica(errorP, false);
                }
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        });

        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarPaginaVisitadaAnalitica(window.location.origin, window.location.pathname, "Inicio");
        }
    }

    setAceptoTerminos = (callback) => {
        this.setState({ aceptoTerminos: callback });
    }

    setCargando = (cargando) => {
        this.setState({ cargando: cargando });
    }

    getSignoMayorQue() {
        if (this.props.marca === "seat")
            return <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                <g id="" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                        <g id="" transform="translate(24.000000, 16.000000)">
                            <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                        </g>
                    </g>
                </g>
            </svg>
        else
            return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
            </svg>
    }

    cerrarError() {
        this.setState({ error: false });
    }

    render() {
        let SetResizeIframe = () => { useResizeEventIframe(this.ref); return null };
        var cerrarError = this.cerrarError;
        return <div ref={this.ref}>
            {this.props.marca === 'audi' && <SetResizeIframe />}
            {this.state.aceptoTerminos === false ?
                <TerminosCondiciones marca={this.props.marca} servicio={this.props.servicio} servicioFirebase={this.props.servicioFirebase} callbackAceptoTerminos={this.setAceptoTerminos} mostrarMenu={this.props.marca !== 'vw'} mostrarFooter={this.props.marca !== 'vw'} />
                :

                <div className={"container__font--" + this.props.marca}>

                    {
                        this.props.marca === "vw" && <BotonCerrarSesion marca={this.props.marca} servicio={this.props.servicio} servicioFirebase={this.props.servicioFirebase} setCargando={this.setCargando} />
                    }

                    <div className={this.state.error ? "d-block" + (this.props.marca === "vw" ? " fixed-top error__container--vw" : "") : "d-none"}>

                        <ErrorBarra mensaje={this.state.errorMensaje} marca={this.props.marca} cerrarError={cerrarError.bind(this)} />

                        {
                            this.props.marca === "vw" ? (
                                <div className="error__cerrar--vw" onClick={() => { this.setState({ error: false }) }}>
                                    <img alt="cerrar" src={process.env.REACT_APP_DOMAIN + "app/sigue-tu-volkswagen/media/cerrar_ico.svg"} height="20" />
                                </div>
                            ) : this.props.marca === "seat" ? (
                                <div className="position-relative">
                                    <div className="error__cerrar--seat" onClick={() => { this.setState({ error: false }) }}>
                                        <svg height="24" viewBox="0 -3 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Combined shape 17</title><desc>Created with Sketch.</desc><g id="Page-1" stroke="none" strokeWidth="1" fill="#ffffff" fillRule="evenodd"><g id="Offers_updating_x" transform="translate(-1398.000000, -174.000000)" fill="#ffffff"><path d="M1416.12818,174.116258 L1418.23413,176.252832 L1410.798,183.581 L1418.48055,190.66644 L1416.44678,192.871808 L1408.659,185.69 L1401.12963,193.11185 L1399.02368,190.975254 L1406.451,183.654 L1398.79168,176.59029 L1400.82548,174.384922 L1408.59,181.545 L1416.12818,174.116258 Z" id="Combined-shape-17"></path></g></g></svg>
                                    </div>
                                </div>
                            ) : ""
                        }

                    </div>

                    {
                        this.props.marca === "vw" && <Header marca={this.props.marca} nfz={this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/")} />
                    }

                    {
                        this.props.marca !== "cupra" &&

                        <div className="container">
                            <div className={"col col-md-12" + this.props.marca === "vw" ? " mt-5" : "pt-3"}>
                                {
                                    this.props.marca === "audi" ? (
                                        <h2>Sigue tu Audi</h2>
                                    ) : (this.props.marca === "vw" ? (
                                        <h1 className="container__titulo--vw  font__title--ligth">Sigue tu<br /> <span className="font__title--bold">Volkswagen</span></h1>
                                    ) : (
                                        this.props.marca === "seat" ?
                                            <div className="container__titulo--seat">
                                                <h2>Sigue tu SEAT</h2>
                                            </div>
                                            : ""
                                    )
                                    )
                                }
                            </div>
                        </div>
                    }

                    {
                        this.state.compras.length > 0 ?
                            <Compras marca={this.props.marca} compras={this.state.compras} servicioFirebase={this.props.servicioFirebase} servicio={this.props.servicio} />
                            :
                            <SinCompras servicioFirebase={this.props.servicioFirebase} marca={this.props.marca} />
                    }

                    <>
                        {
                            this.props.marca !== "vw" && this.props.marca !== "cupra" &&
                            <div>
                                <div className={"container opciones-navegacion"}>
                                    <div className={"col col-md-8 offset-md-2 text-left"}>
                                        <div className="row">
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion opciones-navegacion__opcion--izquierda">
                                                <span className={"cursor-pointer texto--" + this.props.marca + "-hover"} onClick={() => this.props.history.push("/" + this.props.marca + "/historial")}>Historial de Guías </span> <span className="opciones-navegacion__signoMayorque">{this.getSignoMayorQue()}</span>
                                            </div>
                                            <div className="col-auto opciones-navegacion__divisor">
                                                <span>|</span>
                                            </div>
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion">
                                                <span className={"cursor-pointer texto--" + this.props.marca + "-hover"} onClick={() => this.props.history.push("/" + this.props.marca + "/terminosycondiciones")}>Términos y Condiciones </span> <span className="opciones-navegacion__signoMayorque">{this.getSignoMayorQue()}</span>
                                            </div>
                                            <div className="col-auto opciones-navegacion__divisor">
                                                <span>|</span>
                                            </div>
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion opciones-navegacion__opcion--derecha">
                                                <span className={"cursor-pointer texto--" + this.props.marca + "-hover"} onClick={() => {
                                                    if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                                        this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-cerrar-sesion", { marca: this.props.marca, descripcion: "Cierre de Sesion" });
                                                    }
                                                    this.setState({ cargando: true });
                                                    this.props.servicio.cerrarSesion(this.props.marca === "seat" ? process.env.REACT_APP_LOGOUT_REDIRECT_SEAT : (this.props.marca === "audi" ? process.env.REACT_APP_LOGOUT_REDIRECT_AUDI : process.env.REACT_APP_LOGOUT_REDIRECT)).then(data => { window.parent.location = data; this.setState({ cargando: false }); }).catch(err => {
                                                        this.setState({ cargando: false }); console.log(err);
                                                    });
                                                }}>Cerrar Sesión </span> <span className="opciones-navegacion__signoMayorque">{this.getSignoMayorQue()}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            this.props.marca === "cupra" &&

                            <div className={(this.props.marca === "cupra" ? "opciones-navegacion-cupra-fondo" : "")}>
                                <div className={"container opciones-navegacion-cupra"}>
                                    <div className={"col col-md-12 col-lg-8 offset-lg-2 text-left"}>
                                        <div className="row">
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion opciones-navegacion__opcion--izquierda">
                                                <span className={"cursor-pointer text-cupra"} onClick={() => this.props.history.push("/" + this.props.marca + "/historial")}>Historial de Guías</span>
                                            </div>
                                            <div className="col-auto opciones-navegacion__divisor_cupra">
                                                <span>|</span>
                                            </div>
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion">
                                                <span className={"cursor-pointer text-cupra texto-single-row"} onClick={() => this.props.history.push("/" + this.props.marca + "/terminosycondiciones")}>Términos y Condiciones</span>
                                            </div>
                                            <div className="col-auto opciones-navegacion__divisor_cupra">
                                                <span>|</span>
                                            </div>
                                            <div className="col-md col-sm-12 opciones-navegacion__opcion opciones-navegacion__opcion--derecha">
                                                <span className={"cursor-pointer text-cupra"} onClick={() => {
                                                    if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                                                        this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-cerrar-sesion", { marca: this.props.marca, descripcion: "Cierre de Sesion" });
                                                    }

                                                    this.setState({ cargando: true });
                                                    this.props.servicio.cerrarSesion(process.env.REACT_APP_LOGOUT_REDIRECT_CUPRA).then(data => {
                                                        window.parent.location = data
                                                        this.setState({ cargando: false });
                                                    }).catch(err => {
                                                        this.setState({ cargando: false });
                                                        console.log(err);
                                                    });
                                                }}>Cerrar Sesión</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    </>

                    {
                        this.props.marca === "cupra" ?

                            <div className={this.state.cargando ? " d-block" : " d-none"}>
                                <Loading />
                            </div>

                            :

                            <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")} />
                    }
                </div>
            }
        </div>
    }
}

export default withRouter(Inicio);